import React from 'react'
import Hero from './Hero'
function Home() {
    return (
        <div className="main">
            <Hero />
        </div>
    )
}

export default Home
